import React, { useEffect, useRef } from 'react';

export const AutoFocusHeader = ({
  children,
  className,
  tabIndex,
  ...rest
}:
  | {
      children: any;
      className?: string;
      tabIndex?: number;
    }
  | any) => {
  const headerRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (headerRef.current && headerRef.current?.checkVisibility()) {
      headerRef.current.focus();
      headerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [headerRef, children]);
  return (
    <h1
      className={className ?? 'mb-4 mt-2'}
      ref={headerRef}
      tabIndex={tabIndex ?? 0}
      {...rest}
    >
      {children}
    </h1>
  );
};
